import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, OnInit, signal } from '@angular/core';
import { CtaLayout2 } from '@components/cta/components/cta-layout-2/model';
import { ButtonComponent } from '@shared/components/button';
import { Button } from '@shared/components/button/model';
import { ImageComponent } from '@shared/components/image';
import { TitleComponent } from '@shared/components/title';
import { Title } from '@shared/components/title/model';

@Component({
  selector: 'app-cta-layout-2',
  imports: [TitleComponent, ButtonComponent, NgClass, ImageComponent],
  templateUrl: './cta-layout-2.component.html',
  styleUrl: './cta-layout-2.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CtaLayout2Component implements OnInit {
  data = input.required<CtaLayout2>();
  title = signal<Title>(null!);
  subtitle = signal<Title>(null!);
  cta = signal<Button>(null!);
  isBackgroundWhite = signal<boolean>(null!);

  ngOnInit(): void {
    this.isBackgroundWhite.set(!!this.data()?.isBackgroundWhite);
    if (this.data().title) {
      this.title.set({
        level: this.data().titleLevel || 'H3',
        size: {
          mobile: 'H3',
          desktop: 'H3',
        },
        text: this.data().title!,
        color: 'BLACK',
        align: {
          mobile: 'LEFT',
          desktop: 'LEFT',
        },
      });
    }
    if (this.data().subtitle) {
      this.subtitle.set({
        level: 'SPAN',
        type: 'SLASH',
        size: {
          mobile: 'SPAN',
          desktop: 'SPAN',
        },
        color: 'GREY_LIGHT',
        align: {
          mobile: 'LEFT',
          desktop: 'LEFT',
        },
        text: this.data().subtitle!,
      });
    }
    if (this.data().cta?.label) {
      this.cta.set({
        icon: {
          name: 'CHEVRON_RIGHT',
          position: 'RIGHT',
          color: 'BLACK',
        },
        size: 'LARGE',
        label: this.data().cta!.label,
        theme: 'TRANSPARENT_BLACK',
        url: this.data().cta?.url,
      });
    }
  }
}
